import OverdueIcon from '../../assets/Icons/OverdueIcon.svg';
import NeedAttentionIcon from '../../assets/Icons/NeedAttentionIcon.svg';
import TotalIcon from '../../assets/Icons/TotalIcon.svg';
import styles from '../../components/DataTable/DataTable.module.scss';

export type SortConfig = {
    sortBy: string;
    sortOrder: 'asc' | 'desc';
  };

export const columns = [
    { id: 'invoice', label: 'Invoice', width: '10%' },
    { id: 'clientName', label: 'Client Name', width: '17%' },
    { id: 'collector', label: 'Collector', width: '12%' },
    { id: 'practiceGroup', label: 'Practice Group', width: '13%' },
    { id: 'outstandingBalance', label: 'Outstanding Balance', width: '15%' },
    { id: 'invoiceDate', label: 'Invoice Date', width: '10%' },
  ];
  
  export const getFilterButtons = (overdue: number, needsReview: number, total: number ) => {
    return  [
      { type: 'overdue', label: 'Overdue', value: 1, heading: 'Overdue Invoices', count: overdue, icon: OverdueIcon, className: styles.overdueBtn },
      { type: 'needsReview', label: 'Needs Review', value: 2, heading: 'Invoices Needing Attention', count: needsReview, icon: NeedAttentionIcon, className: styles.needsReviewBtn },
      { type: 'total', label: 'All Invoices', value: 0, heading: 'All Open Invoices', count: total, icon: TotalIcon, className: styles.totalResultBtn },
    ]
  }